import { useQuery } from "@tanstack/react-query";
import { Navigate, useParams } from "@tanstack/react-router";
import { Notice, Plate } from "@wilco/ui";
import { t } from "../i18n.ts";
import { stockApi } from "../stock/api.ts";
import { errorNotice } from "../stock/ShelfPage.tsx";

/**
 * Глобальный скан (поле в шапке, сканер вне полей, палитра): полка ведёт
 * на «Полицю», артикул на товар. Серийник и номер документа разберёт
 * сервер, когда появятся их экраны; пока на них ответ «не знайдено».
 */
export function ScanPage() {
  const { code } = useParams({ from: "/app/scan/$code" });
  const resolved = useQuery({ queryKey: ["scan", code], queryFn: () => stockApi.scan(code), retry: false, staleTime: 0, gcTime: 0 });

  if (resolved.data?.kind === "shelf") return <Navigate to="/stock/shelf" search={{ code: resolved.data.code }} replace />;
  if (resolved.data?.kind === "product") return <Navigate to="/stock/product/$sku" params={{ sku: resolved.data.sku }} replace />;

  return (
    <div className="page stock-narrow">
      <h1 className="page-title">{t("scan.label")}</h1>
      {resolved.error ? (
        <Plate key={code} cut="md" bordered className="scan-result w-build-in">
          <h2 className="scan-code w-num">{t("scan.result.title", { code })}</h2>
          <Notice tone="danger" title={errorNotice(resolved.error).title} />
        </Plate>
      ) : null}
    </div>
  );
}
